export function isPastDate(date: Date | undefined) {
    if (!date) {
        return true;
    }
    const currentDate = new Date();
    if (currentDate.getTime() > date.getTime()) {
        return true;
    }

    return false;
}
